module.exports = __webpack_public_path__ + "media/images/icons/youtube-e8ae12f3e35adadadf68078ee78068e1.svg";